import LayerSwitcher from 'ol-ext/control/LayerSwitcher'
import { Control } from 'ol/control'
import Geoportail from "ol-ext/layer/Geoportail";
import LegendControl from "ol-ext/control/Legend";
import Legend  from "ol-ext/legend/Legend";
import Image from "ol-ext/legend/Image";
import { createCustomFullScreenControl } from './helpers.js'
import { geoServerLegendUrl } from './geoserver.js'
import LayerGroup from 'ol/layer/Group'
import {ScaleLine} from "ol/control";
import 'ol-ext/dist/ol-ext.css'
export const scaleLine = new ScaleLine();
const el = scaleLine.element;
Object.assign(el.style, {
    position: 'absolute',
    left: '50%',
    bottom: '10px',
    transform: 'translateX(-50%)',
    zIndex: 1000,
    background: 'rgba(0,0,0,0.6)',
    padding: '4px 8px',
    borderRadius: '6px',
    color: '#fff',
    fontSize: '12px',
});

// estiliza o conteúdo interno (barra/legenda) sem usar classes
const inner = el.firstElementChild; // equivale ao '.ol-scale-line-inner'
if (inner) {
    inner.style.borderColor = '#fff';
    inner.style.color = '#fff';
}
export const layerSwitcher = new LayerSwitcher({
    tipLabel: 'Legenda',
    groupSelectStyle: 'children'
})

// Sobrescreve o método displayInLayerSwitcher para filtrar layers sem título/nome
const originalDisplayInLayerSwitcher = layerSwitcher.displayInLayerSwitcher.bind(layerSwitcher);
layerSwitcher.displayInLayerSwitcher = function(layer) {
    if (!layer || typeof layer.get !== 'function') {
        return false;
    }

    // Primeiro verifica o comportamento padrão
    if (!originalDisplayInLayerSwitcher(layer)) {
        return false;
    }
    
    // Se for LayerGroup, verifica se tem título (permite grupos vazios)
    if (layer instanceof LayerGroup) {
        const title = layer.get('title');
        if (!title) {
            return false;
        }
        // Permite grupos vazios para serem exibidos
        return true;
    }
    
    // Para outras camadas, verifica se tem título ou nome
    const title = layer.get('title');
    const name = layer.get('name');
    if (!title && !name) {
        return false;
    }
    
    return true;
}
layerSwitcher.on('drawlist', function (e) {
    const layer = e.layer;
    if (!layer || typeof layer.get !== 'function') return;

    const buttons = e.li?.children?.[0]
    if (!buttons) return;

    const events = layer.get('actions')

    if (layer instanceof LayerGroup) return

    const button = document.createElement('button');
    button.innerHTML = '<i class="fa-solid fa-question" style="cursor: pointer"></i>';
    button.title = 'Turorial';

    button.style.color = 'white';
    button.style.backgroundColor = '#369';
    button.style.borderRadius = '10px'
    button.style.fontSize = '12px'

    button.onclick = () => {
        let faqiId = layer.get('faq_id')
        events.faq(faqiId)
    }

    const button2 = document.createElement('button');
    button2.innerHTML = '<i class="fa-solid fa-download fa-sm" style="cursor: pointer"></i>';
    button2.title = 'Exportar';

    button2.style.color = 'white';
    button2.style.backgroundColor = '#369';
    button2.style.borderRadius = '10px'
    button2.style.fontSize = '12px'

    button2.onclick = () => {
        let geoTable = layer.get('geo_table')
        let name = layer.get('name')
        events.export(geoTable, name)
    }

    const buttonNotification = document.createElement('button');
    buttonNotification.innerHTML = '<i class="fa-solid fa-bell fa-sm" style="cursor: pointer"></i>';
    buttonNotification.title = 'Notificações';

    buttonNotification.style.color = 'white';
    buttonNotification.style.backgroundColor = '#369';
    buttonNotification.style.borderRadius = '10px';
    buttonNotification.style.fontSize = '12px';

    buttonNotification.onclick = () => {
        if (events?.notification) events.notification(layer);
    };

    if (layer.get('faq_id')) buttons.appendChild(button);
    if (layer.get('geo_table')) buttons.appendChild(button2);
    if (layer.get('isMultifinalitario')) buttons.appendChild(buttonNotification);
});

export const fullScreenBtn = new Control({
    element: createCustomFullScreenControl()
})
export function setupLegend(layerName) {
    let layer = new Geoportail({layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'})
    let url = geoServerLegendUrl(layerName);
    return  new LegendControl({
        legend: new Legend({
            title: 'Legenda',
            margin: 5,
            maxWidth: 300,
            items: [
                new Legend({
                    layer: layer,
                    items: [
                        new Image({
                            title: 'Zonas',
                            src: url
                        })
                    ]
                })
            ]
        }),
        collapsed: false
    })
}

